import React from "react";

import { defineMessages, useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

const messages = defineMessages({
  description: {
    id: "email.resourceUnableToInsertModal.description",
    defaultMessage: "The selected resource does not have a public link and cannot be inserted.",
    description: "Description for unable to insert resource modal",
  },
  title: {
    id: "email.resourceUnableToInsertModal.title",
    defaultMessage: "Unable to insert resource",
    description: "Title for unable to insert resource modal",
  },
});

interface UnableToInsertResourceLinkModalProps {
  onCancel?: () => void;
  onOk?: () => void;
}

export const EmailResourceUnableToInsertModal = ({
  onCancel,
  onOk,
}: UnableToInsertResourceLinkModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      onCancel={onCancel}
      onOk={onOk}
      open
      size="small"
      title={intl.formatMessage(messages.title)}
      type="warning"
    >
      {intl.formatMessage(messages.description)}
    </Modal>
  );
};

export default EmailResourceUnableToInsertModal;
